/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 * @flow
 */
import {
  agentGetPortfolioCodes,
  agentMatchPortfolioCode,
  agentUnmatchPortfolioCode,
  agentVerifyPortfolioCode,
  getUsersEndpoint
} from '../constants/apiRequest/requestConstants/endpoints';
import { PAYLOADVALUE } from '../constants/retriveUserConstant';
import { makeRequest } from '../helpers/makeApiRequest';
import type { MatchingServiceResponse } from '../types';


export const getUsers = async (values: any) => {
  const requestObject = { [PAYLOADVALUE[`${values.dropdownValue}`]]: values.searchInput, starts_with: true };

  const response = await makeRequest({
    method: 'POST',
    url: getUsersEndpoint,
    payload: requestObject
  });

  return response?.error ? [] : response;
};

export const verifyPortfolioCode = async (portfolioCode: string) => {
  const response = await makeRequest({
    method: 'GET',
    url: `${agentVerifyPortfolioCode}/${portfolioCode}`
  });
  return response?.error ? false : response;
};


// eslint-disable-next-line flowtype/no-weak-types
export const getPortfolioCodes = async (values: any) => {
  const requestObj = { 'third_party_identifier': values.data.username };
  const response = await makeRequest({
    method: 'POST',
    url: agentGetPortfolioCodes,
    payload: requestObj
  });
  return response?.error ? [] : response;
};

// eslint-disable-next-line flowtype/no-weak-types
export const matchUserToPortfolioCode = async (values: any): Promise<?MatchingServiceResponse> => {
  const response = await makeRequest({
    method: 'POST',
    url: agentMatchPortfolioCode,
    payload: values
  });
  return response?.error ? undefined : response;
};

export const unMatchUserToPortfolioCode = async (values: any) => {
  const response = await makeRequest({
    method: 'POST',
    url: agentUnmatchPortfolioCode,
    payload: values
  });
  return response?.error ? [] : response;
};
